import { IAssets } from './assets';

export interface IProperty {
  propId: string;
  propName: string;
  propType: string;
  propLocation: string;
  propLastAccessed?: string;
  propLastAccessedDateTime?: string;
  propCreateDate: string;
  propRemoveDate?: string;
  propModifyDate?: string;
  totalAssets: number;
  assetDetails: IAssets[];
}
export const initIProperty: IProperty = {
  propId: '',
  propName: '',
  propType: '',
  propLocation: '',
  propLastAccessed: '',
  propLastAccessedDateTime: '',
  propCreateDate: '',
  propRemoveDate: '',
  propModifyDate: '',
  totalAssets: null,
  assetDetails: [],
};
